import { __assign, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "../_core/components";
import { useConfig } from "../_util/use-config";
export function TypographyHeading(_a) {
    var _b;
    var _c = _a.level, level = _c === void 0 ? 1 : _c, ellipsis = _a.ellipsis, className = _a.className, props = __rest(_a, ["level", "ellipsis", "className"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement(View, __assign({ className: classNames(classPrefix + "-typography", classPrefix + "-heading", "level-h" + level, className, (_b = {},
            _b[classPrefix + "-ellipsis"] = ellipsis,
            _b)) }, props)));
}
//# sourceMappingURL=Heading.js.map